export default {
  list: [
    {
      value: 'true',
      title: 'منتشر شده',
    },
    {
      value: 'false',
      title: 'منتشر نشده',
    },
    {
      value: 'null',
      title: 'هردو',
    },
  ],
  values: {
    BOTH: 'BOTH',
    PUBLISHED: 'PUBLISHED',
    NOT_PUBLISHED: 'NOT_PUBLISHED',
  },
};
